import React, { useEffect, useState } from 'react';

import css from './CookieNotice.module.css';

// The inline script in public/index.html reads the same key and value before the first paint
// (CookieNotice.test.js keeps the two in sync).
export const STORAGE_KEY = 'delowoCookieNoticeSeen:v1';
export const STORAGE_VALUE = 'true';
const OPEN_EVENT_NAME = 'delowo:openCookieNotice';

// D49: the banner is part of the server markup, so a new visitor sees it from the first frame.
// The first client render equals the server's (§12.6); a returning visitor's banner is already
// hidden by CSS (the <html> attribute set by the inline script) and leaves the DOM after mount.
const CookieNotice = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(STORAGE_KEY) === STORAGE_VALUE) {
        setIsBannerVisible(false);
      }
    } catch (e) {
      // If storage is blocked, keep notice visible.
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const openDetails = () => {
      setIsDetailsOpen(true);
    };

    window.addEventListener(OPEN_EVENT_NAME, openDetails);
    return () => window.removeEventListener(OPEN_EVENT_NAME, openDetails);
  }, []);

  const handleAcknowledge = () => {
    if (typeof window !== 'undefined') {
      try {
        window.localStorage.setItem(STORAGE_KEY, STORAGE_VALUE);
      } catch (e) {
        // Ignore storage failures and still allow dismissal.
      }
    }

    setIsBannerVisible(false);
    setIsDetailsOpen(false);
  };

  if (!isBannerVisible && !isDetailsOpen) {
    return null;
  }

  return (
    <>
      {isDetailsOpen ? (
        <div className={css.detailsOverlay} role="dialog" aria-modal="true" aria-label="Cookies и похожие технологии">
          <div className={css.detailsPanel}>
            <div className={css.detailsHeader}>
              <h2 className={css.detailsTitle}>Cookies и похожие технологии</h2>
              <button type="button" className={css.detailsCloseButton} onClick={() => setIsDetailsOpen(false)}>
                Закрыть
              </button>
            </div>

            <div className={css.detailsSection}>
              <h3 className={css.sectionTitle}>Необходимые — всегда активны.</h3>
              <p className={css.sectionText}>
                Нужны для входа в аккаунт, безопасности, платежей и базовой работы сайта. Включают Sharetribe
                authentication/session cookies и Stripe payment/security cookies.
              </p>
            </div>

            <div className={css.detailsSection}>
              <h3 className={css.sectionTitle}>Функциональные.</h3>
              <p className={css.sectionText}>
                Карта и поиск по локации используют Mapbox. Mapbox может сохранять технические данные в браузере,
                включая данные, связанные с работой карты и location features.
              </p>
            </div>

            <div className={css.detailsSection}>
              <h3 className={css.sectionTitle}>Аналитика без cookies.</h3>
              <p className={css.sectionText}>
                Мы используем Plausible Analytics для измерения посещаемости, источников трафика, вовлечённости и
                базовых действий на сайте. Plausible не использует cookies и не применяется для рекламного
                профилирования.
              </p>
            </div>

            <div className={css.detailsSection}>
              <h3 className={css.sectionTitle}>Маркетинг.</h3>
              <p className={css.sectionText}>
                Маркетинговые cookies, рекламные pixels, Google Analytics, Google Tag Manager, Meta Pixel, Hotjar и
                Microsoft Clarity сейчас не используются.
              </p>
            </div>
          </div>
        </div>
      ) : null}

      {isBannerVisible ? (
        <div className={css.bannerWrap}>
          <div className={css.banner}>
            <p className={css.bannerText}>
              Мы используем cookies и похожие технологии для входа в аккаунт, безопасности, платежей и работы сайта.
              Карта и поиск по локации используют Mapbox, который может сохранять технические данные в браузере.
              Также мы используем Plausible Analytics без cookies, чтобы понимать посещаемость и улучшать MVP.
              Маркетинговые cookies сейчас не используются.
            </p>

            <div className={css.bannerActions}>
              <button type="button" className={css.primaryButton} onClick={handleAcknowledge}>
                Понятно
              </button>
              <button type="button" className={css.secondaryButton} onClick={() => setIsDetailsOpen(true)}>
                Подробнее
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CookieNotice;
